import { render, staticRenderFns } from "./Atendimento.vue?vue&type=template&id=5d3c07b6&scoped=true"
import script from "./Atendimento.vue?vue&type=script&lang=js"
export * from "./Atendimento.vue?vue&type=script&lang=js"
import style0 from "./Atendimento.vue?vue&type=style&index=0&id=5d3c07b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c07b6",
  null
  
)

export default component.exports